import { render, staticRenderFns } from "./LandingFaq.vue?vue&type=template&id=01c9030e&scoped=true"
import script from "./LandingFaq.vue?vue&type=script&lang=js"
export * from "./LandingFaq.vue?vue&type=script&lang=js"
import style0 from "./LandingFaq.vue?vue&type=style&index=0&id=01c9030e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c9030e",
  null
  
)

export default component.exports